export default __webpack_public_path__ + "static/media/twentyeightdays1.7c249365.jpg";